module.exports = __webpack_public_path__ + "static/willpower-ff1b8a89801a406a7f128616279796fa.jpg";